import React from 'react';
import { Modal } from "react-bootstrap";

import logout from  "../../assets/img/logout.svg"


const ModalSesionCerrada = ({mensaje2}) => {
	return (
		<Modal
			show={true}
			animation={false}
			centered
			className='modalogin1'
		>
			<div id="modalcampos">
				<Modal.Body>
					<div className="contmodal fondoazul modales_cerrar col-xs-12 modalogin">

						<div className="col-xs-12">
							<div className="col-xs-12 centra">
								<div className="titular_modal">
									<img src={logout} alt=""/>
									<h2>Sesión cerrada</h2>
								</div>
							</div>
						</div>

						<div className="modal-body">
							 {mensaje2}
						</div>
					</div>
				</Modal.Body>
			</div>
		</Modal>
	);
}

export default ModalSesionCerrada;